var _defs, _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.008,
    height: 29.008,
    viewBox: "0 0 29.008 29.008",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ffbe46;}.b{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 13.38,
    cy: 13.38,
    r: 13.38,
    transform: "translate(1.123 1.123)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.5,29.008a14.5,14.5,0,1,1,14.5-14.5A14.521,14.521,0,0,1,14.5,29.008Zm0-26.761A12.257,12.257,0,1,0,26.761,14.5,12.271,12.271,0,0,0,14.5,2.247Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M149.38,236.453H138.145a1.123,1.123,0,0,1,0-2.247H149.38a1.123,1.123,0,1,1,0,2.247Z",
    transform: "translate(-129.259 -220.937)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.b028ae3bcfe0ff1a019f1f6870e6e5b4.svg";
export { ForwardRef as ReactComponent };